"use client";

import { jsx as d, jsxs as S } from "react/jsx-runtime";
import { createContext as A, useState as k, forwardRef as g, useContext as l } from "react";
import { classNames as u } from "../../utilities/index.js";
import I from "../Icon/index.js";
const x = A(null),
  C = A(null),
  p = _ref => {
    let {
      allowMultiple: t,
      defaultOpen: c,
      className: r,
      children: o,
      variant: e = "list",
      ...s
    } = _ref;
    const [n, i] = k({
        [c]: !0
      }),
      f = u({
        "sash-Accordion my-6 block": !0,
        "border-b border-gray-42": e === "list",
        "space-y-2": e === "box",
        [r]: r
      }),
      m = a => {
        i(t ? {
          ...n,
          [a]: !n[a]
        } : {
          [a]: !n[a]
        });
      };
    return /* @__PURE__ */d(x.Provider, {
      value: {
        variant: e,
        onTriggerClick: m,
        openSections: n
      },
      children: /* @__PURE__ */d("div", {
        className: f,
        ...s,
        children: o
      })
    });
  },
  b = g((_ref2, o) => {
    let {
      className: t,
      children: c,
      value: r
    } = _ref2;
    const e = l(x),
      s = u({
        "sash-AccordionItem block border-gray-42": !0,
        "border-t": e.variant === "list",
        border: e.variant === "box",
        [t]: t
      });
    return /* @__PURE__ */d(C.Provider, {
      value: {
        value: r
      },
      children: /* @__PURE__ */d("div", {
        className: s,
        ref: o,
        children: c
      })
    });
  }),
  h = g((_ref3, s) => {
    let {
      className: t,
      activeIcon: c = "remove",
      inactiveIcon: r = "add",
      children: o,
      showIcon: e = !0
    } = _ref3;
    var m, a, v;
    const n = l(x),
      i = l(C),
      f = u({
        "sash-AccordionBtn relative flex w-full items-center p-4 text-left text-subtitle-2 md:py-5 md:pr-4 md:pl-6 md:tracking-0.25px": !0,
        "sash-AccordionBtn--active": (m = n.openSections) == null ? void 0 : m[i.value],
        [t]: t
      });
    return /* @__PURE__ */S("button", {
      onClick: () => n.onTriggerClick(i.value),
      className: f,
      "aria-expanded": (a = n.openSections) != null && a[i.value] ? "true" : "false",
      ref: s,
      children: [/* @__PURE__ */d("div", {
        className: "flex-1 leading-tight",
        children: o
      }), e && /* @__PURE__ */d(I, {
        name: (v = n.openSections) != null && v[i.value] ? c : r,
        className: "ml-4 flex h-8 w-8 items-center justify-center text-center text-2xl !leading-none md:text-3xl"
      })]
    });
  }),
  y = g((_ref4, r) => {
    let {
      className: t,
      children: c
    } = _ref4;
    const o = l(x),
      e = l(C),
      s = u({
        "sash-AccordionContent px-6 pb-4": !0,
        block: o.openSections[e.value],
        hidden: !o.openSections[e.value],
        [t]: t
      });
    return /* @__PURE__ */d("div", {
      className: s,
      "aria-hidden": o.openSections[e.value] ? "false" : "true",
      ref: r,
      children: c
    });
  });
b.displayName = "Accordion.Item";
h.displayName = "Accordion.Trigger";
y.displayName = "Accordion.Content";
p.Item = b;
p.Trigger = h;
p.Content = y;
const B = p;
export { B as default };